import { createSelector } from "reselect";
import { woundAssessmentTotalsTimeSeriesByLocationSelector } from "../wound_assessment_totals_time_series_by_location_selector";

export const woundAssessmentTotalsTimeSeriesByLocationLoadStateSelector = createSelector(
  woundAssessmentTotalsTimeSeriesByLocationSelector,
  totalsSeries => totalsSeries.loadState
);
